<template>
  <div class="">
    <div class="" v-if="isDone">
      <div class="relative hero-container bg-gray-800 pb-8">
        <div class="absolute inset-0 z-0">
          <img
            :src="`https://image.tmdb.org/t/p/original${detailData.backdrop_path}`"
            :alt="detailData.title"
            class="w-full h-full object-cover"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/80"></div>
        </div>
        <div class="container mx-auto flex flex-col md:flex-row items-end relative z-10" style="height: 350px;">
          <div class="w-full md:w-1/4"></div>
          <div class="w-full md:w-3/4 md:ml-12 text-center md:text-start">
            <h1 class="mt-12 md:mt-0 font-semibold text-3xl text-white tracking-wide uppercase">
              {{ detailData.title }}
            </h1>
            <p class="font-light text-gray-200">
              Action, Magic
            </p>
          </div>
        </div>
      </div>
      <div class="container mx-auto flex flex-col md:flex-row p-3 md:p-0 relative z-10">
        <div class="w-full md:w-1/4">
          <img :src="imagePath(detailData.poster_path)" alt="movie cover"
               class="-mt-44 md:-mt-52 rounded-sm mb-6 w-52 md:w-full">
          <div class="mb-4">
            <span class="font-semibold">Released: </span>
            <span class="">{{ new Date(detailData.release_date).toDateString()}}</span>
          </div>
          <div class="mb-6 text-center">
            <h1 class="font-semibold text-5xl">
              {{ detailData.vote_average.toFixed(1)*10+'%' }}
            </h1>
            <p class="font-semibold">Overall Ratings</p>
          </div>
        </div>
        <div class="w-full md:w-3/4 md:ml-12 py-8 leading-normal">
          <p class="mb-12">
            {{ detailData.overview }}
          </p>
          <div class="mt-12">
            <h4 class="text-white font-semibold">Featured Crew</h4>
            <div class="flex mt-4">
              <div class="" v-for="(crew, index) in crews" :key="index">
                <div class="mr-8" v-if="index < 2">
                  <div class="">{{ crew.name }}</div>
                  <div class="text-sm text-gray-400">{{ crew.job }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-10" v-if="videos.length > 0">
            <button @click="isVidoOpen = !isVidoOpen; modalVideo='https://youtube.com/embed/'+videos[0]['key'];"
                    class="bg-orange-500 hover:bg-orange-600
                        text-gray-900 py-4 px-5 rounded
                        font-semibold transition ease-in-out duration-150 capitalize">
              <i class="fa-solid fa-circle-play mr-2"></i>
              play trailer
            </button>
            <!--          Video Modal Container Start-->
            <div style="background: rgba(0,0,0,.5)" v-show="isVidoOpen"
                 class="fixed top-0 left-0 w-full h-screen flex items-center shadow-lg overflow-y-auto">
              <div class="container mx-auto lg:px-32 rounded-lg overflow-y-auto">
                <div class="bg-gray-900 rounded">
                  <div class="flex justify-end pr-4 pt-2">
                    <button @click="isVidoOpen = !isVidoOpen;"
                            class="text-3xl leading-none hover:text-gray-300">
                      &times;
                    </button>
                  </div>
                  <div class="modal-body p-8">
                    <div class="responsive-container overflow-hidden relative" style="padding-top: 56.25%">
                      <iframe
                          width="560"
                          height="315"
                          class="responsive-iframe absolute top-0 left-0 w-full h-full " id="youtube-movie"
                          :src="modalVideo"
                          frameborder="0" allowfullscreen>
                      </iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--          Video Modal Container End-->
          </div>
          <div class="mt-14 border-b border-gray-800">
            <h2 class="text-4xl font-semibold">Cast</h2>
            <div class="flex flex-wrap -mx-4 mt-6" >
              <div :class="['game-card w-1/2 md:w-1/5 px-4 mb-10', { 'hidden':  cast.order>9} , {'hidden': cast.profile_path == null}]"
                   v-for="cast in casts" :key="cast.cast_id" >
                <div class="" v-if="cast.profile_path != null && cast.order < 10">
                  <router-link :to="{name: 'actor', params: {id: cast.id}}" class="">
                    <img :src="castImagePath(cast.profile_path)"
                         alt="game cover"
                         class="hover:opacity-75 transition
                                    ease-in-out duration-150 rounded-sm">
                  </router-link>
                  <div class="mt-4">
                    <router-link :to="{name: 'actor', params: {id: cast.id}}"
                                 class="hover:text-gray-500 block truncate
                            text-base font-semibold leading-tight" :title="cast.name">
                      {{ cast.name }}
                    </router-link>
                    <div class="text-gray-400 mt-1">
                      <i class="fa-solid fa-star text-orange-500 mr-1"></i>{{ Math.floor(cast.popularity) }} %
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8">
            <h2 class="text-4xl font-semibold">Images</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mt-8">
              <div :class="{'hidden': index > 8}" v-for="(image, index) in images.backdrops" :key="index">
                <div class="hover:cursor-pointer" v-if="index < 9"
                     @click="isImageOpen = !isImageOpen; modalImage = modalImagePath(image.file_path)">
                  <img :src="imagePath(image.file_path)"
                       alt="movie screenShot"
                       class="hover:opacity-75 transition ease-in-out duration-150">
                </div>
              </div>
              <!--            Modal Container Start -->
              <div style="background: rgba(0,0,0,.5)" v-show="isImageOpen"
                   class="fixed top-0 left-0 w-full h-screen flex items-center shadow-lg overflow-y-auto">
                <div class="container mx-auto lg:px-28 rounded-lg overflow-y-auto">
                  <div class="bg-gray-900 rounded">
                    <div class="flex justify-end pr-4 pt-2">
                      <button @click="isImageOpen = !isImageOpen"
                              @keydown.esc ="isImageOpen = !isImageOpen"
                              class="text-3xl leading-none hover:text-gray-300">&times;</button>
                    </div>
                    <div class="modal-body p-4">
                      <img :src="modalImage" alt="modal image" class="rounded">
                    </div>
                  </div>
                </div>
              </div>
              <!--            Modal Container End -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto px-4" v-else>
      <div class="flex justify-center items-center min-h-screen pb-28 lg:pb-16">
        <img src="../assets/loading.gif" alt="loading" class="w-80">
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Modal from "@/components/Modal";

export default {
  name: "DetailView",
  data() {
    return {
      id: '',
      detailData: [],
      casts: [],
      crews: [],
      videos: [],
      images: [],
      isImageOpen: false,
      isVidoOpen: false,
      modalImage: '',
      modalVideo: '',
      isDone: false,
    }
  },
  computed: {
    videoLink(){
      return 'https://youtube.com/watch?v='+this.videos[0]['key'];
    },
  },
  methods: {
    stopIframe(){
      let iframe = document.getElementById('youtube-movie');
      let iframeSrc = iframe.src;
      console.log(iframeSrc);
    },
    imagePath(image) {
      return  'https://image.tmdb.org/t/p/w500/'+image;
    },
    modalImagePath(image) {
      return  'https://image.tmdb.org/t/p/original/'+image;
    },
    castImagePath(image) {
      return  'https://image.tmdb.org/t/p/w200/'+image;
    },
    callDetailApi(){
      this.id = this.$route.params.id;
      let token= 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5Y2Q5ZDIzMWMyZWNmOWVlMjMwNTQ1MjY2MDA0NGU1YSIsInN1YiI6IjYyYWMxOGNiZDdjZDA2MDA5Mjk5ZTNiYSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.8aPeoTYZyUOuN72OyZbXh7gDcw6-RhwVJ4vIedUaeFo';
      axios.get(`https://api.themoviedb.org/3/movie/${this.id}`,{
        headers: {"Authorization" : `Bearer ${token}`}
      })
          .then(res => {
            this.detailData = res.data;
          })
          .catch(error => console.log(error));

      axios.get(`https://api.themoviedb.org/3/movie/${this.id}/credits`,{
        headers: {"Authorization" : `Bearer ${token}`}
      })
          .then(res => {
            this.casts = res.data.cast;
            this.crews = res.data.crew;
          })
          .catch(error => console.log(error));

      axios.get(`https://api.themoviedb.org/3/movie/${this.id}/videos`,{
        headers: {"Authorization" : `Bearer ${token}`}
      })
          .then(res => this.videos = res.data.results)
          .catch(error => console.log(error));

      axios.get(`https://api.themoviedb.org/3/movie/${this.id}/images`,{
        headers: {"Authorization" : `Bearer ${token}`}
      })
          .then(res => this.images = res.data)
          .catch(error => console.log(error));
    }
  },
  created() {
    this.callDetailApi();
    setTimeout(() => {
      this.isDone = true;
    }, 2000);
  }
}
</script>

<style scoped>

</style>